import { render, staticRenderFns } from "./DocumentViewer.vue?vue&type=template&id=7d32f04a&scoped=true"
import script from "./DocumentViewer.vue?vue&type=script&lang=js"
export * from "./DocumentViewer.vue?vue&type=script&lang=js"
import style0 from "./DocumentViewer.vue?vue&type=style&index=0&id=7d32f04a&prod&lang=scss&scoped=true"
import style1 from "./DocumentViewer.vue?vue&type=style&index=1&id=7d32f04a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d32f04a",
  null
  
)

export default component.exports